import classNames from 'classnames';
import EFPicture from 'elem/ui/ef-picture';
import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import './index.scss';

export interface EfSwiperCardItemProps {
    /**
     * title文本
     */
    title: string;
    /**
     * description文本
     */
    desc: string;
    /**
     * 图片PC端
     */
    pc: string;
    /**
     * 图片M端
     */
    h5?: string;
}

interface EfSwiperCardProps {
    /**
     * 样式名
     */
    className?: string;
    /**
     * 列表
     */
    lists: EfSwiperCardItemProps[];
}

/**
 * 维护: kalkin
 *
 * 图文组合swiper卡片
 */
const EfSwiperCard: React.FC<EfSwiperCardProps> = ({ lists = [], className }) => {
    const prefixCls = `ef-swiper-card`;
    const [gap, setGap] = React.useState(24);
    const classes = classNames(prefixCls, {
        [`${className}`]: className,
    });

    React.useEffect(() => {
        if (typeof window !== 'undefined') {
            const resetGap = () => {
                const winW = window.innerWidth;
                if (winW >= 1440) {
                    return setGap(24);
                } else if (winW > 1024) {
                    return setGap(20);
                } else {
                    return setGap(16);
                }
            };
            resetGap();
        }
    }, []);

    return (
        <div className={classes}>
            <Swiper
                className={`${prefixCls}-swiper-box`}
                spaceBetween={gap}
                // centeredSlides={true}
                slidesPerView={'auto'}
                initialSlide={0}
            >
                {lists?.map((card: any, k: number) => (
                    <SwiperSlide className={`${prefixCls}-swiper-item ${prefixCls}-item-${k + 1}`} key={k}>
                        <div className={`${prefixCls}-card-img`}>
                            <EFPicture src={card?.pc} srcPad={card?.h5 || card?.pc} srcMobile={card?.h5 || card?.pc} alt={card.title} />
                        </div>
                        <div className={`${prefixCls}-card-info`}>
                            <p className={`${prefixCls}-card-title`}>{card?.title}</p>
                            <p className={`${prefixCls}-card-desc`}>{card?.desc}</p>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
};

export default EfSwiperCard;
